<template>
  <div class="wrapper">
    <side-bar>
      <!-- <mobile-menu slot="content"></mobile-menu> -->
      <sidebar-link to="/admin/campaigns">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Campaigns</p>
      </sidebar-link>
      <sidebar-link to="/admin/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>Profile</p>
      </sidebar-link>
      <sidebar-link v-if="user && user.isAdmin" to="/admin/create-client">
        <i class="nc-icon nc-badge"></i>
        <p>Create Client</p>
      </sidebar-link>
      <sidebar-link v-if="user && user.isAdmin" to="/admin/create-user">
        <i class="nc-icon nc-circle-09"></i>
        <p>Create User</p>
      </sidebar-link>
      <sidebar-link v-if="user && user.isAdmin" to="/admin/create-campaign">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Create Campaign</p>
      </sidebar-link>
      <sidebar-link to="/logout">
        <i class="nc-icon nc-button-power"></i>
        <p>Logout</p>
      </sidebar-link>
      <!-- <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-notes"></i>
        <p>Table list</p>
      </sidebar-link>
      <sidebar-link to="/admin/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/admin/icons">
        <i class="nc-icon nc-atom"></i>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/admin/notifications">
        <i class="nc-icon nc-bell-55"></i>
        <p>Notifications</p>
      </sidebar-link>

      <template slot="bottom-links">
        <sidebar-link class="active"
                      to="/admin/upgrade">
          <i class="nc-icon nc-alien-33"></i>
          <p>Upgrade to PRO</p>
        </sidebar-link>
      </template> -->
    </side-bar>
    <div class="main-panel">
      <!-- <top-navbar></top-navbar> -->

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    data () {
      return {
        user: '',
        loading: false,
      }
    },
    async created() {
      const app = getApp()
      const functions = getFunctions(app, 'europe-west1')
      // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
      await this.getUser(functions)
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    methods: {
      async getUser(functions) {
        try {
          const getUser = httpsCallable(functions, 'getUser');
          const getUserRes = await getUser()
          this.user = getUserRes.data.data
        } catch (error) {
          alert('Error getting User. Error: ' + error)
        }
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
